import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchLeadListResponse>}
 */
export function requestBrokerFirmOwners(param) {
    if (param) {
        return fetch.get(`${BASE_URL}/api/app/subscriber-user/get-users?${param}`)
    } else {
        return fetch.get(`${BASE_URL}/api/app/subscriber-user/get-users`)
    }
}
